if (!customElements.get('mo-purchase')) customElements.define('mo-purchase', class extends HTMLElement {
  connectedCallback() {
    this.onPageShow ||= event => {
      if (!event.persisted) return;
      // Back/forward cache restores the checkout lock along with the page.
      this.checkoutBusy = false;
      this.querySelector('[name="add"]').removeAttribute('aria-busy');
      this.update();
    };
    window.addEventListener('pageshow', this.onPageShow);
    if (this.initialized) return;
    this.initialized = true;
    const media = this.closest('product-info')?.querySelector('.product__media-item .product-media-container') || document.querySelector('.product__media-item .product-media-container');
    const seal = this.querySelector('[data-mo-tiktok-seal]');
    if (media && seal && !media.querySelector('.mo-tiktok-seal')) {
      media.classList.add('mo-tiktok-host');
      media.append(seal.content.cloneNode(true));
    }
    this.data = JSON.parse(this.querySelector('[data-mo-data]').textContent);
    this.money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:this.data.currency || 'USD'}).format(cents / 100);
    this.addEventListener('change', () => this.update());
    this.addEventListener('submit', event => this.checkout(event), true);
    this.addEventListener('click', event => {
      const button = event.target.closest('[name="add"]');
      if (button) this.checkout(event, button.form);
    }, true);
    const requestedPlan = new URL(location.href).searchParams.get('selling_plan');
    if (requestedPlan && this.data.variants.some(v => v.plans.some(p => String(p.id) === requestedPlan))) this.querySelector('input[value="subscription"]').checked = true;
    this.update();
    this.sticky = this.querySelector('.mo-sticky');
    document.body.append(this.sticky);
    this.observer = new IntersectionObserver(entries => {
      this.sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
    });
    this.observer.observe(this.querySelector('product-form'));
  }
  disconnectedCallback() {
    window.removeEventListener('pageshow', this.onPageShow);
    this.observer?.disconnect();
    this.sticky?.remove();
  }
  async checkout(event, form = event.target) {
    if (!form.matches('form[data-type="add-to-cart-form"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = this.querySelector('[name="add"]');
    if (this.checkoutBusy || button.disabled) return;
    this.checkoutBusy = true;
    const label = button.querySelector('span');
    const originalLabel = label.textContent;
    const error = this.querySelector('.product-form__error-message-wrapper');
    error.hidden = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    label.textContent = 'GOING TO CHECKOUT…';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', headers: {Accept:'application/json'}, body: new FormData(form)
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
      const protection = this.querySelector('[data-mo-protection]');
      if (protection && typeof window.bdEnsureShippingProtection !== 'function')
        throw new Error('Please refresh the page to confirm your shipping protection choice.');
      await window.bdEnsureShippingProtection?.(protection?.checked);
      window.location.assign(root + 'checkout');
    } catch (failure) {
      error.querySelector('.product-form__error-message').textContent = failure.message || 'Unable to open checkout. Please try again.';
      error.hidden = false;
      this.checkoutBusy = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      label.textContent = originalLabel;
    }
  }
  update() {
    const selected = this.querySelector('input[name^="mo-bundle-"]:checked');
    const variant = this.data.variants.find(v => String(v.id) === selected.value);
    const recurring = this.querySelector('input[name^="mo-frequency-"]:checked').value === 'subscription';
    const plan = recurring ? variant.plans[0] : null;
    const subscriptionCost = variant.plans[0]?.price;
    const subscriptionSavings = subscriptionCost < variant.price ? Math.round((variant.price - subscriptionCost) / variant.price * 100) : 0;
    this.querySelector('[data-mo-subscribe-title]').textContent = 'Subscribe & Save' + (subscriptionSavings > 0 ? ' ' + subscriptionSavings + '%' : '');
    const price = plan ? plan.price : variant.price;
    const months = parseInt(variant.title, 10) || 1;
    this.querySelector('[data-mo-frequency-label]').textContent = (months === 1 ? 'Every month' : 'Every ' + months + ' months') + ' · Cancel anytime';
    this.querySelector('input[name="id"]').value = variant.id;
    const planInput = this.querySelector('input[name="selling_plan"]');
    planInput.value = plan?.id || '';
    planInput.disabled = !plan;
    this.querySelectorAll('.mo-card').forEach(card => {
      const item = this.data.variants.find(v => String(v.id) === card.querySelector('input').value);
      const cost = recurring && item.plans[0] ? item.plans[0].price : item.price;
      const count = parseInt(item.title, 10) || 1;
      card.querySelector('.mo-price').textContent = this.money(cost);
      const discounted = cost < item.price;
      const savings = card.querySelector('.mo-savings');
      const original = card.querySelector('.mo-original-price');
      savings.hidden = !discounted;
      original.hidden = !discounted;
      savings.textContent = discounted ? 'Save ' + Math.round((item.price - cost) / item.price * 100) + '%' : '';
      savings.title = discounted ? 'Save ' + this.money(item.price - cost) + ' compared with this bundle’s one-time price' : '';
      original.textContent = discounted ? this.money(item.price) : '';
      original.setAttribute('aria-label', discounted ? 'One-time price ' + this.money(item.price) : '');
      card.querySelector('.mo-unit').textContent = this.money(cost / count) + ' / bottle';
    });
    const button = this.querySelector('[name="add"]');
    button.disabled = this.checkoutBusy || !variant.available || (recurring && !plan);
    button.querySelector('span').textContent = variant.available ? 'ADD TO CART · ' + this.money(price) : 'SOLD OUT';
  }
});
